import React from 'react';
import { Badge } from 'react-bootstrap';
import cn from 'classnames';
import styles from './base-item-card.module.css';
import { ItemBadge, ItemMetadata } from './types';

interface ItemCardContentProps {
  description?: string;
  badges?: ItemBadge[];
  metadata?: ItemMetadata[];
  layout?: 'compact' | 'standard' | 'detailed';
}

export const ItemCardContent: React.FC<ItemCardContentProps> = ({
  description,
  badges,
  metadata,
  layout = 'standard'
}) => {
  console.log('[ItemCardContent] RENDERED');

  const isCompact = layout === 'compact';

  if (
    !description &&
    (!badges || badges.length === 0) &&
    (!metadata || metadata.length === 0)
  ) {
    return null;
  }

  return (
    <div className={styles.cardContent}>
      {/* Badges */}
      {badges && badges.length > 0 && (
        <div className={styles.badges}>
          {badges.map((badge, index) => (
            <Badge
              key={index}
              bg={badge.variant}
              className={styles.badge}
              title={badge.tooltip}
            >
              {badge.text}
            </Badge>
          ))}
        </div>
      )}

      {/* Description */}
      {description && (
        <p
          className={cn(styles.description, {
            [styles.compact]: isCompact
          })}
        >
          {description}
        </p>
      )}

      {/* Metadata */}
      {metadata && metadata.length > 0 && (
        <div className={styles.metadata}>
          {metadata.map((meta, index) => (
            <div
              key={index}
              className={cn(styles.metadataItem, {
                [styles.clickable]: !!meta.onClick
              })}
              onClick={meta.onClick}
              role={meta.onClick ? 'button' : undefined}
              tabIndex={meta.onClick ? 0 : undefined}
              onKeyDown={(e) => {
                if (meta.onClick && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  meta.onClick();
                }
              }}
            >
              {meta.icon && (
                <span className={styles.metadataIcon}>{meta.icon}</span>
              )}
              {meta.label && (
                <span className={styles.metadataLabel}>{meta.label}</span>
              )}
              <span className={styles.metadataValue}>{meta.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
